import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const SigurnosnePoruke: IModel = {
  title: "Sigurnosna podrucja",
  apiPath: "sigurnosna-podrucja",
  httpUpdateVerb: "put",
  forms: {
    "default": {
      fields: ["id", "naziv", "wkt", "created_on", "modified_on", "sigurnosne_poruke"]
    },
  },
  listViews: {
    "default": {
      fields: ["id", "naziv", "wkt", "created_by", "created_on", "modified_by", "modified_on", "active"],
      hidden: ["id", "wkt"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "naziv",
      source: "naziv",
      ttoken: "sigurnosna_podrucja.naziv",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "wkt",
      source: "wkt",
      ttoken: "sigurnosna_podrucja.wkt",
      type: "wkt",
      filter: false,
      validation: {
        required: true
      },
    },
   coreFields.modified_on,
   coreFields.modified_by,
   coreFields.created_by,
   coreFields.created_on,
   {
    title: "sigurnosne_poruke",
    source: "sigurnosne_poruke",
    ttoken: "sigurnosna_podrucja.sigurnosne_poruke",
    type: "checkbox",
    filter: true,
    subModel: {
      apiPath: "sigurnosne-poruke?view=picker",
      format: "{label}"
    }
  
  },
  commonFields.proj,
  coreFields.active
    
  ]
}

export default SigurnosnePoruke;
